import get from "lodash.get";
import { ProviderData } from "../../../lib/appContext/types";

export const BASE_IMG_URL = "https://d7nxjt1whovz0.cloudfront.net/marketplace/";

export interface IBusinessUnit {
  businessUnitCode: string;
  countryCode: string;
}

const getBUBaseUrl = (businessUnit: IBusinessUnit) =>
  `${BASE_IMG_URL}${businessUnit.countryCode}/${businessUnit.businessUnitCode}/`;

export const getEducationImage = (
  businessUnit: IBusinessUnit,
  educationTip: string,
  size: "1x1" | "4x3" | "16x9" | "xs"
) =>
  `${getBUBaseUrl(businessUnit)}educations/${educationTip}/main-images/${educationTip}-${size}.jpg`;

export const getBusinessUnitImage = (buConfig: Pick<ProviderData, "businessUnitConfig">) =>
  get(buConfig, "landings.results.hero.bgImage", false);
